<template>
  <div>
    <v-sheet v-if="filteredIssuesSummaryTypes">
      <v-tabs
        v-model="issuesSummaryType"
        grow
        next-icon="mdi-arrow-right-bold-box-outline"
        prev-icon="mdi-arrow-left-bold-box-outline"
        show-arrows
        hide-slider
      >
        <v-tab
          v-for="item in filteredIssuesSummaryTypes"
          :key="item.id"
          class="hyp-issues-tabs"
          @click="handleChangeIssuesSummaryType(item)"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>
    </v-sheet>

    <v-container class="hyp-issues-details-container">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-container class="hyp-issues-tab-items mt-3">
            <v-row>
              <v-col
                id="hyp-issues-content-wrapper"
                cols="12"
                class="pt-0 pb-1 content-container hyp-issues-grid"
                :class="gridColumnClass"
              >
                <GridContentContainerWrapper
                  v-if="noDataInfo"
                  class="mb-2 pa-3"
                  wrapper-id="issues-no-data"
                  wrapper-container-id="hyp-issues-content-wrapper"
                  :reset-expanded="resetExpanded"
                  :grid-expanded="gridColumnExpanded"
                  :show-grid-expand-icon="!gridColumnExpanded"
                >
                  <GlobalIssuesProfile
                    :profile-info="noDataInfo"
                  ></GlobalIssuesProfile>
                </GridContentContainerWrapper>
                <GridContentContainerWrapper
                  v-if="headlineParams"
                  :wrapper-class="'pt-3 pr-3'"
                  wrapper-id="issues-headlines"
                  wrapper-container-id="hyp-issues-content-wrapper"
                  :reset-expanded="resetExpanded"
                  :grid-expanded="gridColumnExpanded"
                  :show-grid-expand-icon="!gridColumnExpanded"
                >
                  <GlobalIssuesHeadlines
                    :headline-params="headlineParams"
                    @click-close="handleClickClose"
                  ></GlobalIssuesHeadlines>
                </GridContentContainerWrapper>
                <GridContentContainerWrapper
                  v-if="profileOverviewInfo"
                  class="pa-3"
                  wrapper-id="issues-profile-overview"
                  wrapper-container-id="hyp-issues-content-wrapper"
                  :reset-expanded="resetExpanded"
                  :grid-expanded="gridColumnExpanded"
                  :show-grid-expand-icon="!gridColumnExpanded"
                >
                  <GlobalIssuesProfile
                    :profile-info="profileOverviewInfo"
                  ></GlobalIssuesProfile>
                </GridContentContainerWrapper>
                <GridContentContainerWrapper
                  v-if="profileBackgroundInfo"
                  class="pa-3"
                  wrapper-id="issues-profile-background"
                  wrapper-container-id="hyp-issues-content-wrapper"
                  :reset-expanded="resetExpanded"
                  :grid-expanded="gridColumnExpanded"
                  :show-grid-expand-icon="!gridColumnExpanded"
                >
                  <GlobalIssuesProfile
                    :profile-info="profileBackgroundInfo"
                  ></GlobalIssuesProfile>
                </GridContentContainerWrapper>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import lodashFind from "lodash/find";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashOrderBy from "lodash/orderBy";

import { getGlobalIssuesData } from "@/services/globalIssues/issues.service";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CLICK_CLOSE: "click-close",
};

export default {
  name: "GlobalIssuesContent",
  components: {
    GridContentContainerWrapper: () =>
      import("@/components/common/GridContentContainerWrapper"),
    GlobalIssuesHeadlines: () =>
      import("@/components/globalIssues/GlobalIssuesHeadlines"),
    GlobalIssuesProfile: () =>
      import("@/components/globalIssues/GlobalIssuesProfile"),
  },
  props: {},
  data: () => ({
    forceClose: null,
    resetExpanded: new Date().toISOString(),
    issuesSummaryType: null,
    selectedIssuesSummaryType: null,
    globalIssuesSummaryTypes: [],
  }),
  async mounted() {
    this.globalIssuesSummaryTypes = await getGlobalIssuesData();

    this.selectedIssuesSummaryType = this.filteredIssuesSummaryTypes
      ? lodashCloneDeep(this.filteredIssuesSummaryTypes[0])
      : null;
    this.issuesSummaryType = -1;
  },
  computed: {
    filteredIssuesSummaryTypes() {
      let filteredList = this.globalIssuesSummaryTypes?.filter((tag) => {
        if (tag.isActive) {
          return tag;
        }
      });

      filteredList = lodashOrderBy(filteredList, ["order"], ["asc"]);
      return filteredList;
    },
    gridColumnExpanded() {
      return this.selectedIssuesSummaryType?.gridColumn < 2 ? true : false;
    },
    gridColumnClass() {
      return this.selectedIssuesSummaryType?.gridColumn === 1
        ? "hyp-issues-grid-1"
        : this.selectedIssuesSummaryType?.gridColumn === 2
        ? "hyp-issues-grid-2"
        : "hyp-issues-grid-3";
    },
    headlineParams() {
      return this.selectedIssuesSummaryType?.headlineParams;
    },
    noDataInfo() {
      return lodashFind(this.selectedIssuesSummaryType?.profiles, (obj) => {
        return obj.type === "nodatamessage";
      });
    },
    profileOverviewInfo() {
      return lodashFind(this.selectedIssuesSummaryType?.profiles, (obj) => {
        return obj.type === "overview";
      });
    },
    profileBackgroundInfo() {
      return lodashFind(this.selectedIssuesSummaryType?.profiles, (obj) => {
        return obj.type === "background";
      });
    },
  },
  methods: {
    handleClickClose() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE);
    },
    handleChangeIssuesSummaryType(type) {
      this.selectedIssuesSummaryType = type;
      this.resetExpanded = new Date().toISOString();

      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.global_issues,
        EVENT_ACTIONS.clicked,
        type.id + " - " + type.label
      );
    },
  },
};
</script>

<style scoped>
.hyp-issues-details-container {
  margin: 0;
  padding: 0;
  max-width: unset !important;
  line-height: 1.5;
}
.hyp-issues-tab-items {
  height: 86vh;
  overflow-y: hidden;
  padding-top: 0;
  padding-bottom: 0;
  max-width: unset !important;
}
.hyp-issues-tabs {
  text-transform: capitalize;
}
.hyp-issues-tabs.v-tab {
  border-bottom: 0px solid;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.hyp-issues-tabs.v-tab.v-tab--active {
  border-bottom: 2px solid;
}
.hyp-issues-details-container .theme--light.v-tabs-items {
  background-color: unset;
}
.hyp-issues-grid {
  max-height: 86vh;
  overflow-y: hidden;
}
.hyp-issues-grid-1 {
  display: grid;
  grid-template-columns: 100%;
}
.hyp-issues-grid-2 {
  display: grid;
  grid-template-columns: 49.5% 49.5%;
  grid-column-gap: 1%;
  overflow-x: auto;
  grid-template-areas:
    "left right1"
    "left right2"
    "left right3"
    "left right4"
    "left right5";
}
.hyp-issues-grid-2-left {
  grid-area: left;
}
.hyp-issues-grid-3 {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-column-gap: 0.5%;
  overflow-x: auto;
  grid-template-areas:
    "left middle right"
    "left middle right"
    "left middle right"
    "left middle right"
    "left middle right"
    "left middle right";
}
</style>
